import Link from "next/link";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import { Container } from "./DesignSystem";

export default function Breadcrumbs({ items }) {
  if (!items?.length) return null;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };

  return (
    <>
      <div className="border-b border-water-border bg-water-canvas">
        <Container>
          <nav aria-label="Breadcrumb" className="overflow-x-auto py-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            <ol className="flex min-w-max items-center gap-1.5 text-sm text-water-muted">
              {items.map((item, index) => {
                const last = index === items.length - 1;
                const href = item.url?.startsWith("https://waterdoctor.ca") ? item.url.replace("https://waterdoctor.ca", "") || "/" : item.url;
                return (
                  <li key={`${item.name}-${item.url}`} className="flex items-center gap-1.5">
                    {index ? <ChevronRightIcon className="h-4 w-4 text-slate-400" aria-hidden="true" /> : null}
                    {last ? (
                      <span aria-current="page" className="font-medium text-water-ink">{item.name}</span>
                    ) : (
                      <Link href={href} className="rounded-sm transition-colors hover:text-water-blue focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-water-blue focus-visible:ring-offset-2">{item.name}</Link>
                    )}
                  </li>
                );
              })}
            </ol>
          </nav>
        </Container>
      </div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
    </>
  );
}
